module.exports = __webpack_public_path__ + "img/closearrow.3ddaaf05.svg";